// extracted by mini-css-extract-plugin
export default {"color-container":"ColorEdit_color-container__eb6+d","manual-input":"ColorEdit_manual-input__Yxu6j","value-container":"ColorEdit_value-container__Kzr0o"};